export const environment = {
    production: false,
    organizationName: "Mut für Kinder e.V.",
    alternativeName: "MfK",
    baseUrl: "https://mut-fuer-kinder.de"
};